import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const InterviewIcon = (): JSX.Element => (
  <SVGUniqueID>
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <rect width={32} height={32} rx={16} fill="#FFCB4A" />
        <path
          d="M13.905 33.555h4.185a5.38 5.38 0 0 0 5.38-5.38v-6.577a5.38 5.38 0 0 0-5.38-5.38h-4.185a5.38 5.38 0 0 0-5.38 5.38v6.577a5.38 5.38 0 0 0 5.38 5.38"
          fill="#fff"
        />
        <path
          d="M23.285 29.58a5.38 5.38 0 0 1-5.195 3.974h-4.184a5.38 5.38 0 0 1-5.38-5.38V21.6a5.34 5.34 0 0 1 1.195-3.372 31 31 0 0 0 5.2 6.014 28 28 0 0 0 2.398 1.93 30.6 30.6 0 0 0 5.966 3.408"
          fill="#EFEFEF"
        />
        <path
          d="M20.48 9.942c0 .084 0 .173-.011.257a4.478 4.478 0 0 1-8.943 0c-.012-.084-.012-.173-.012-.257a4.485 4.485 0 0 1 4.483-4.483 4.485 4.485 0 0 1 4.484 4.483"
          fill="#FCDA35"
        />
        <path
          d="M20.48 9.942c0 .084 0 .173-.011.257a4.2 4.2 0 0 1-2.959-.693 4.25 4.25 0 0 1-1.513-1.895 4.18 4.18 0 0 1-4.471 2.588c-.012-.084-.012-.173-.012-.257a4.485 4.485 0 0 1 4.483-4.483 4.485 4.485 0 0 1 4.484 4.483"
          fill="#FF56CB"
        />
        <path
          d="m17.41 26.915-1.061-8.499a1.8 1.8 0 0 1 .078-.79l.47-1.407h-1.794l.469 1.407c.085.254.111.524.078.79l-1.062 8.499c-.053.427.048.86.288 1.218l.825 1.237h.597l.825-1.238c.24-.358.342-.79.288-1.218"
          fill="#B45656"
        />
        <path
          d="m17.123 28.132-.825 1.238H15.7l-.825-1.238a1.8 1.8 0 0 1-.287-1.22l.335-2.671a28 28 0 0 0 2.397 1.93l.09.742c.054.43-.048.86-.287 1.22"
          fill="#B45656"
        />
        <path
          d="M16.296 29.669h-.598c-.1 0-.193-.05-.248-.133l-.825-1.238a2.1 2.1 0 0 1-.336-1.421l1.063-8.498a1.5 1.5 0 0 0-.066-.66l-.468-1.407a.3.3 0 0 1 .283-.393h1.793a.298.298 0 0 1 .283.395l-.469 1.407a1.5 1.5 0 0 0-.065.659l1.062 8.498a2.1 2.1 0 0 1-.335 1.42l-.825 1.239a.3.3 0 0 1-.249.132m-.437-.598h.278l.736-1.105c.199-.298.284-.658.24-1.015l-1.063-8.498a2.1 2.1 0 0 1 .091-.922l.338-1.014h-.964l.338 1.014c.099.296.13.614.092.922l-1.063 8.498c-.044.357.041.717.24 1.015zm.138-14.347a4.79 4.79 0 0 1-4.782-4.782 4.79 4.79 0 0 1 4.464-4.772.304.304 0 0 1 .318.279.3.3 0 0 1-.279.318 4.19 4.19 0 0 0-3.905 4.175 4.19 4.19 0 0 0 4.184 4.184 4.19 4.19 0 0 0 3.75-6.043.299.299 0 1 1 .535-.266 4.7 4.7 0 0 1 .498 2.125 4.79 4.79 0 0 1-4.783 4.782"
          fill="#09092D"
        />
        <path
          d="M18.09 33.854h-4.184a5.685 5.685 0 0 1-5.68-5.68V21.6a5.685 5.685 0 0 1 5.68-5.68h4.184a5.685 5.685 0 0 1 5.68 5.68v6.576a5.685 5.685 0 0 1-5.68 5.679m-4.184-17.336A5.087 5.087 0 0 0 8.824 21.6v6.576a5.087 5.087 0 0 0 5.082 5.081h4.184a5.087 5.087 0 0 0 5.081-5.081V21.6a5.087 5.087 0 0 0-5.08-5.081z"
          fill="#09092D"
        />
        <path
          d="M20.48 33.256a.3.3 0 0 1-.298-.3V21.002a.3.3 0 0 1 .598 0v11.956a.3.3 0 0 1-.3.299m-8.966 0a.3.3 0 0 1-.3-.3v-2.39a.299.299 0 0 1 .599 0v2.39a.3.3 0 0 1-.3.3M19.285 21.3H18.09a.299.299 0 0 1 0-.598h1.195a.3.3 0 0 1 0 .598M18.09 10.138a.3.3 0 0 1-.127-.03 4.51 4.51 0 0 1-2.546-4.439.296.296 0 0 1 .324-.272.3.3 0 0 1 .272.324q-.015.165-.015.335c0 1.493.872 2.872 2.22 3.513a.298.298 0 0 1-.127.568m-6.577 17.739a.3.3 0 0 1-.3-.299v-2.989a.299.299 0 0 1 .599 0v2.99a.3.3 0 0 1-.3.298m0-4.782a.3.3 0 0 1-.3-.3v-1.793a.3.3 0 0 1 .599 0v1.794a.3.3 0 0 1-.3.299"
          fill="#09092D"
        />
        <path
          d="M11.25 10.056c0 .089 0 .183.013.272a4.741 4.741 0 0 0 9.469 0c.012-.089.012-.183.012-.272a4.75 4.75 0 0 0-4.747-4.747 4.75 4.75 0 0 0-4.746 4.747"
          fill="#FCDA35"
        />
        <path
          d="M11.25 10.056c0 .089 0 .183.013.272a4.44 4.44 0 0 0 3.133-.734 4.5 4.5 0 0 0 1.601-2.006 4.426 4.426 0 0 0 4.735 2.74c.012-.089.012-.183.012-.272a4.75 4.75 0 0 0-4.747-4.747 4.75 4.75 0 0 0-4.746 4.747"
          fill="#7F1D1D"
        />
        <path
          d="M11.884 10.688a4.752 4.752 0 0 0 4.7-5.416.32.32 0 0 0-.358-.269.317.317 0 0 0-.268.358 4.12 4.12 0 0 1-4.654 4.654.316.316 0 1 0-.089.627q.33.045.67.046"
          fill="#09092D"
        />
        <path
          d="M20.783 10.642q-.331.047-.67.047a4.725 4.725 0 0 1-4.407-2.982.317.317 0 0 1 .587-.235 4.1 4.1 0 0 0 3.82 2.584q.294 0 .581-.04a.32.32 0 0 1 .358.268.317.317 0 0 1-.27.358"
          fill="#09092D"
        />
        <circle
          cx={15.997}
          cy={9.942}
          r={4.845}
          stroke="#09092D"
          strokeWidth={0.598}
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width={32} height={32} rx={16} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { InterviewIcon };
